import React from 'react';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  display: flex;
`;

export default ProgressBarContainer;
